import React, { useEffect, useState } from "react";
import { InfoCircleOutlined } from "@ant-design/icons";
import {
  Modal,
  Form,
  Input,
  DatePicker,
  Switch,
  Button,
  InputNumber,
  Tooltip,
} from "antd";

import dayjs from "dayjs";

import { displayMessage, postAPI } from "../../utils/common";

import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../constants/messages";

import { FESTIVAL_STORE, FESTIVAL_UPDATE } from "../../constants/api";

function FestivalModal({ open, close, editData, afterSave }) {
  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (editData) {
      form.setFieldsValue({
        name: editData.name,

        start_date: editData.start_date ? dayjs(editData.start_date) : null,

        end_date: editData.end_date ? dayjs(editData.end_date) : null,

        impact_score: editData.impact_score,

        status: editData.status == 1,
      });
    } else {
      form.resetFields();

      form.setFieldsValue({
        status: true,
      });
    }
  }, [editData, open]);

  /*
  |--------------------------------------------------------------------------
  | Submit
  |--------------------------------------------------------------------------
  */

  const handleSubmit = () => {
    form.validateFields().then((values) => {
      setLoading(true);

      const data = new FormData();

      data.append("name", values.name);

      if (values.start_date) {
        data.append("start_date", values.start_date.format("YYYY-MM-DD"));
      }

      if (values.end_date) {
        data.append("end_date", values.end_date.format("YYYY-MM-DD"));
      }

      data.append("impact_score", values.impact_score);

      data.append("status", values.status ? 1 : 0);

      if (editData) {
        data.append("id", editData.id);
      }

      const successFn = (res) => {
        setLoading(false);

        if (res.status === true) {
          displayMessage(SUCCESS_MESSAGE, res.message);

          afterSave();
        } else {
          displayMessage(ERROR_MSG_TYPE, res.message);
        }
      };

      const errorFn = () => {
        setLoading(false);

        displayMessage(ERROR_MSG_TYPE, "Something went wrong");
      };

      postAPI(
        editData ? FESTIVAL_UPDATE : FESTIVAL_STORE,

        data,

        successFn,

        errorFn,
      );
    });
  };

  return (
    <Modal
      title={editData ? "Edit Festival" : "Add Festival"}
      open={open}
      onCancel={close}
      footer={null}
      destroyOnClose
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label="Festival Name"
          name="name"
          rules={[
            {
              required: true,

              message: "Please enter festival name",
            },
          ]}
        >
          <Input placeholder="Enter festival name" />
        </Form.Item>

        <Form.Item
          name="start_date"
          label="Start Date"
          rules={[
            {
              required: true,
              message: "Start date is required",
            },
          ]}
        >
          <DatePicker
            style={{
              width: "100%",
            }}
          />
        </Form.Item>
        <Form.Item
          name="end_date"
          label="End Date"
          rules={[
            {
              required: true,
              message: "End date is required",
            },
          ]}
        >
          <DatePicker
            style={{
              width: "100%",
            }}
          />
        </Form.Item>

        <Form.Item
          name="impact_score"
          label={
            <span>
              Impact Score{" "}
              <Tooltip
                placement="top"
                title={
                  <>
                    This score is used by the Smart Pricing engine to measure
                    how much a festival can increase room demand.
                    <br />
                    <br />
                    Higher score = Higher demand = Greater chance of price
                    increase.
                    <br />
                    <br />
                    Example:
                    <br />
                    • Small local event: 5–10
                    <br />
                    • Regional festival: 10–15
                    <br />• Major festival (Diwali, New Year, etc.): 20–25
                  </>
                }
              >
                <InfoCircleOutlined
                  style={{
                    color: "#1677ff",
                    cursor: "pointer",
                  }}
                />
              </Tooltip>
            </span>
          }
          rules={[
            {
              required: true,
              message: "Impact score is required",
            },
          ]}
        >
          <InputNumber
            style={{
              width: "100%",
            }}
            placeholder="Enter score"
          />
        </Form.Item>

        <Form.Item label="Status" name="status" valuePropName="checked">
          <Switch />
        </Form.Item>

        <Form.Item>
          <Button type="primary" loading={loading} onClick={handleSubmit} block>
            {editData ? "Update" : "Save"}
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default FestivalModal;
